module.exports = __webpack_public_path__ + "static/img/tw.bf719cfa.svg";